export class RegistrationRequestDto {
    constructor(public firstName: string,
                public lastName: string,
                public password: string,
                public locale: string,
                public userId: string) {
    }
}

